module.exports = __webpack_public_path__ + "cancellara-live-dist/img/hero-splash.caabc3c7.png";